<template>
    <f-app-screen class="safe-area-top safe-area-bottom">
        <div class="grow keen-slider pt-8 pb-4" ref="sliderEl">
            <tutorial-slide
                    v-for="idx in slidesCount"
                    :key="idx"
                    :index="idx"
            />
        </div>

        <div v-if="slider" class="dots">
            <button
                    v-for="(n, idx) in dotCount"
                    :key="idx"
                    @click="goToSlide(idx)"
                    :class="{ dot: true, 'bg-green': current === idx, 'bg-slate-blue-900': current !== idx }"
            />
        </div>

        <div class="p-4">
            <template v-if="isLastSlide">
                <nav-button
                        :label="$t('tutorial2.button.finish.pro')"
                        @click="goPro()"
                />
                <button
                        class="mt-2 w-full font-bold px-5 py-3 leading-7"
                        @click="goFree()"
                >{{$t('tutorial2.button.finish.free')}}</button>
            </template>

            <nav-button
                    v-else
                    :label="$t('tutorial2.button.continue')"
                    @click="next()"
            />
        </div>
    </f-app-screen>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import NavButton from '@/components/NavButton.vue'
import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'
import Analytics, { SCREEN_TUTORIAL } from '@/services/Analytics'
import TutorialSlide from '@/modules/core/TutorialSlide.vue'

const emit = defineEmits(['finished'])

const slidesCount = ref(5)
const current = ref(0)
let slider = ref(null)
const dotCount = ref(0)
const sliderEl = ref(null)

const isLastSlide = computed(() => current.value === dotCount.value - 1)

function next() {
  slider.value?.next()
}

function goToSlide(idx) {
  slider.value?.moveToIdx(idx)
}

function goFree() {
  emit('finished', { showPro: false })
}

function goPro() {
  emit('finished', { showPro: true })
}

onMounted(() => {
  Analytics.setScreenName(SCREEN_TUTORIAL)
  slider.value = new KeenSlider(sliderEl.value, {
    initial: current.value,
    loop: false,
    mode: 'snap',
    drag: true,
    slides: {
      perView: 1,
      spacing: 24,
      origin: 'center',
    },
    slideChanged: (e) => {
      current.value = e.track.details.rel
    },
    created: (e) => {
      dotCount.value = e.track.details.slides.length
    }
  })
})

onBeforeUnmount(() => {
  slider.value?.destroy()
})
</script>

<style scoped lang="scss">

.dots {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}

.dot {
  border: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 10px;
  padding: 5px;
  cursor: pointer;
}

.dot:focus {
  outline: none;
}
</style>
